import component from './AcceptWorkspaceInvitation.vue'
export default component
